import {
	Card,
	CardBody,
	Input,
	TableRow,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import ExportDataXlsx from 'components/common/ExportDataXlsx';
import AirportPickupPeriodicHikeDayTable from 'components/airportPickupPeriodicHikeDay/AirportPickupPeriodicHikeDayTable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import { SidebarContext } from 'context/SidebarContext';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useContext, useEffect } from 'react';
import AirportPickupPeriodicHikeDayServices from 'services/AirportPickupPeriodicHikeDayServices';
import { FiPlus } from 'react-icons/fi';
import AirportPickupPeriodicHikeDayDrawer from 'components/drawer/AirportPickupPeriodicHikeDayDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';

import sidebar from 'routes/sidebar';

const AirportPickupPeriodicHikeDay = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { toggleDrawer } = useContext(SidebarContext);
	const [status, setStatus] = useState('');
	const { title, serviceId } = useToggleDrawer();
	const { data, loading, error } = useAsync(
		AirportPickupPeriodicHikeDayServices.getAllAirportPickupPeriodicHikeDay
	);

	const isDataArray = Array.isArray(data?.data); // Check if data is an array
	const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

	const isAdmin = adminInfo?.id === 1;

	const hideView = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'airport periodic hike day' && perm.view === 1
		  );

	const hideDelete = adminInfo?.permission?.some(
				(perm) =>
					perm.id_tab === 'airport periodic hike day' && perm.delete === 1
		  );

	const hideEdit = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'airport periodic hike day' && perm.edit === 1
		  );

	const hideAdd = adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'airport periodic hike day' && perm.add === 1
		  );

	const hideExport = adminInfo?.permission?.some(
				(perm) =>
					perm.id_tab === 'airport periodic hike day' && perm.export === 1
		  );
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const {
		airportPickupPeriodicHikeDayRef,
		serviceData,
		dataTable,
		handleSubmitAirportPickupPeriodicHikeDay,
		currentPage,
	} = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);
	const updatedData = safeData.map(({ id, ...rest }) => rest);
	// console.log("airport periodic hikeday", updatedData);
	
	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);

	const finalData = data?.data?.map((item, itemIndex) => {
  const vehicleIds = item.vehicle_type_id || [];
  const vehicleNames = item.vehicle_type_names || {};

  const vehicleTypes = vehicleIds
    .map((vid) => vehicleNames[vid] || vid)
    .join("\n");

  const hike = vehicleIds
  .map((vid) => {
    const val = item.hike?.[vid];
    return val ? `${val}%` : ""; 
  })
  .join("\n");


  return {
    "SI.No": itemIndex + 1,
    "Airport": item.city_names, 
	"Start Date": item.start_date, 
	"End Date": item.end_date,
    "Vehicle Type": vehicleTypes, 
    "Hike": hike,
  };
});
	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />

					<MainDrawer>
						<AirportPickupPeriodicHikeDayDrawer id={serviceId} />
					</MainDrawer>

					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div className="flex gap-6 items-center">
								<div className="flex-1">
									<Input
										ref={airportPickupPeriodicHikeDayRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										placeholder="Quick Search"
										autoComplete="off"
										onChange={handleSubmitAirportPickupPeriodicHikeDay}
									/>
								</div>

								{hideAdd && (
									<Button
										onClick={toggleDrawer}
										className="w-56 rounded-md h-10"
									>
										<span className="mr-3">
											<FiPlus />
										</span>
										Add Periodic Day Rate
									</Button>
								)}

								{hideExport && (
									<ExportDataXlsx
										exportDataXlsx={finalData}
										fileNames="Airport Pickup Periodic Hike Day"
									/>
								)}
							</div>
						</CardBody>
					</Card>

					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData.length ? (
							<TableContainer>
								<div
									className="overflow-y-scroll"
									style={{ maxHeight: '67vh', scrollbarWidth: 'thin' }}
								>
									<Table>
										<TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
											<TableRow>
												<TableCell>Sl.No.</TableCell>
												<TableCell>Airport</TableCell>
												<TableCell>Start Date</TableCell>
												<TableCell>End Date</TableCell>
												<TableCell>Vehicle Type</TableCell>
												<TableCell>Hike (%)</TableCell>
												<TableCell>Actions</TableCell>
											</TableRow>
										</TableHeader>
										<AirportPickupPeriodicHikeDayTable
											airportPickupPeriodicHikeDay={dataTable}
											perpage={itemsPerPage}
											currentPage={currentPage}
											hideDelete={hideDelete}
											hideEdit={hideEdit}
										/>
									</Table>
								</div>
							</TableContainer>
						) : (
							<>
								{data.status !== true ? (
									<Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
								) : (
									<NotFound title="There are no Airport Pickup Periodic Hike Day." />
								)}
							</>
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default AirportPickupPeriodicHikeDay;
